import * as React from "react";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import styles from "./Select.module.css";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

interface leadProps {
  id: number;
  name: string;
  onCreate: (id: number) => void;
  onDelete: (id: number) => void;
}

interface SelectButtonRef {
  clearSelection: () => void;
}

export const SelecttButton = React.forwardRef<SelectButtonRef, leadProps>(
  ({ id, name, onCreate, onDelete }, ref) => {
    const [option, setOption] = React.useState("");

    React.useImperativeHandle(ref, () => ({
      clearSelection: () => {
        setOption("");
      },
    }));

    const handleChange = (event: SelectChangeEvent) => {
      setOption(event.target.value as string);
      // Chamar a função apropriada com base na seleção
      switch (event.target.value) {
        case "criar":
          onCreate(id);
          break;
        case "remover":
          onDelete(id);
          break;
        default:
          console.info(`Ação desconhecida: ${event.target.value}`);
      }
    };

    return (
      <Box>
        <FormControl fullWidth>
          <Select
            className={styles.Select}
            value={option}
            onChange={handleChange}
            displayEmpty
            renderValue={() => <MoreHorizIcon/>}
            inputProps={{ "aria-label": "Without label" }}
            IconComponent={() => null} // Remove a seta padrão do Select
            sx={{
              backgroundColor: '#EDE8E3',
              border: "none", // Remove a borda
              "& fieldset": { border: "none" }, // Remove a borda do contorno
              "&:hover .MuiOutlinedInput-notchedOutline": {
                border: "none",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                border: "none",
              }
            }}
          >
            <MenuItem value={"criar"}>Criar atendimento</MenuItem>
            <MenuItem value={"remover"}>Remover</MenuItem>
          </Select>
        </FormControl>
      </Box>
    );
  }
);
